<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        class="reservationModal"
        title="予約内容のご確認"
        ref="ReservationConfirmModal"
        hide-header
        hide-footer
        @hidden="close">
        <div v-if="isLoadedState">
            <div class="card mb-3">
                <div class="card-header">{{ completed ? '予約内容' : '予約内容のご確認' }}</div>
                <div class="card-body">
                    <div class="modalContent">
                        <section class="modalSection">
                            <div class="reservationTimes">
                                <div>予約日時</div>
                                <div class="u-palt">
                                    <span>{{ helper.dateForHumanNoConvert(schedule.date) }}</span>
                                    <span :class="helper.dayForHumanNoConvertCSS(schedule.date)">
                                        {{ helper.dayForHumanNoConvert(schedule.date, {bracket: true}) }}
                                    </span>
                                    <span class="d-inline-block d-md-inline mt-1 mb-1 ml-0 mt-md-0 mb-md-0 ml-md-1">
                                        {{ helper.displayTimeNoConvert(schedule.start_time, schedule.end_time) }}
                                    </span>
                                    <span class="ml-0 ml-md-1">
                                        {{ `（${doctorMenu ? doctorMenu.consultation_minutes : medicalCourse.matching_minutes}分）` }}
                                    </span>
                                </div>
                                <div
                                    v-if="user.timezone !== 'Asia/Tokyo' && jstConsultationStart"
                                    class="vc-timezone-box u-palt">
                                    <span>{{ helper.dateForHumanNoConvert(jstConsultationStart) }}</span>
                                    <span :class="helper.dayForHumanNoConvertCSS(jstConsultationStart)">
                                        {{ helper.dayForHumanNoConvert(jstConsultationStart, { bracket: true }) }}
                                    </span>
                                    <span class="ml-1">{{ jstConsultationTimeFormat }}</span>
                                </div>
                            </div>
                        </section>

                        <template v-if="doctorMenu !== null">
                            <hr class="divide">

                            <section class="modalSection">
                                <div class="d-block d-md-flex align-items-center mb-2">
                                    <div class="doctorMenuDoctorImage">
                                        <img
                                            v-if="doctorMenu.doctor.presigned_url"
                                            :src="doctorMenu.doctor.presigned_url">
                                        <img
                                            v-else
                                            src="/images/common/profile_default.svg">
                                    </div>
                                    <div class="doctorMenuDoctorDetail">
                                        <div class="doctorMenuDoctorName">
                                            <span>{{ doctorMenu.doctor.full_name }}</span>
                                            <span v-if="!isStaff">医師</span>
                                        </div>
                                        <div>
                                            <div
                                                v-for="course in doctorMenu.doctor.medical_courses"
                                                class="doctorMenuDoctorMedicalCourse">
                                                {{ course.name }}
                                            </div>
                                        </div>
                                        <div class="mt-2 pt-1">
                                            <div
                                                v-for="label in doctorMenu.doctor.doctor_labels"
                                                class="doctorMenuDoctorLabel">
                                                {{ label.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="hasDoctorIntroduction(doctorMenu)">
                                    <div
                                        class="descriptionWrapper"
                                        :class="{ 'descriptionWrapperExtended' : isShowDoctorIntroduction }">
                                        <div v-if="doctorMenu.doctor.introduction !== null">
                                            <div class="description">{{ doctorMenu.doctor.introduction }}</div>
                                            <hr class="divide">
                                        </div>
                                        <div
                                            v-if="doctorMenu.doctor.doctor_histories.length > 0"
                                            :class="{ 'mt-3' : doctorMenu.doctor.introduction !== null }">
                                            <div class="doctorMenuDoctorHistory">
                                                <div class="doctorMenuDoctorHistoryTitle">略歴</div>
                                                <div
                                                    v-for="history in doctorMenu.doctor.doctor_histories"
                                                    class="doctorMenuDoctorHistory">
                                                    <span>{{ history.accrual_year }}年</span><!--
                                                 --><span>{{ history.content }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-if="doctorMenu.doctor.doctor_licenses.length > 0"
                                            :class="{ 'mt-3' : doctorMenu.doctor.doctor_histories.length > 0 }">
                                            <div class="doctorMenuDoctorLicense">
                                                <div class="doctorMenuDoctorLicenseTitle">資格・所属学会等</div>
                                                <div
                                                    v-for="license in doctorMenu.doctor.doctor_licenses"
                                                    class="doctorMenuDoctorLicense">
                                                    <span>{{ license.content }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="isShowDoctorIntroduction === false"
                                        @click="isShowDoctorIntroduction = true"
                                        class="descriptionExtender">
                                        ▼&nbsp;全文を表示
                                    </div>
                                </template>
                            </section>

                            <hr class="divide">

                            <section class="modalSection modalSectionPaddingTop">
                                <doctor-menu-base-info
                                    :menu="doctorMenu"
                                    :user="user"
                                    :user-coupons="filteredUserCoupons"
                                    :static-subtotal="estimate ? estimate.subtotal : null">
                                </doctor-menu-base-info>

                                <template v-if="doctorMenu.description !== null">
                                    <div
                                        class="descriptionWrapper mt-1"
                                        :class="{ 'descriptionWrapperExtended' : isShowDoctorMenuDescription }">
                                        <div class="description">{{ doctorMenu.description }}</div>
                                    </div>
                                    <div
                                        v-if="isShowDoctorMenuDescription === false"
                                        @click="isShowDoctorMenuDescription = true"
                                        class="descriptionExtender">
                                        ▼&nbsp;全文を表示
                                    </div>
                                </template>
                            </section>
                        </template>
                        <template v-else>
                            <hr class="divide">

                            <section class="modalSection modalSectionPaddingTop">
                                <doctor-menu-base-info
                                    :menu="helper.matchingDoctorMenu(medicalCourse)"
                                    :user="user"
                                    :user-coupons="filteredUserCoupons"
                                    :static-subtotal="estimate ? estimate.subtotal : null">
                                </doctor-menu-base-info>
                                <div class="descriptionWrapper descriptionWrapperExtended mt-1">
                                    <div class="description">{{ helper.matchingDoctorMenuDesc() }}</div>
                                </div>
                            </section>
                        </template>
                    </div>

                    <div
                        v-if="!completed && !helper.isDraftByDoctor(prevConsultation)"
                        class="reservationConfirmBackWrapper d-block d-md-flex justify-content-end">
                        <div
                            class="btn btn-yokumiru-gray mb-2 mr-md-2 mb-md-2"
                            @click="backToDoctorMenuDetailModal">
                            日時選択に戻る
                        </div>
                        <div
                            class="btn btn-yokumiru-gray mb-2 mr-md-2 mb-md-2"
                            @click="backToDoctorMenusModal">
                            メニュー選択に戻る
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="isPayPrice">
                <div class="card mb-3">
                    <div class="card-header">お支払い方法</div>
                    <div class="card-body">
                        <dl class="mb-0">
                            <dd class="mb-0">
                                <span>{{ paymentMethod.name }}</span>
                            </dd>
                        </dl>
                        <div
                            v-if="!completed && !isGroupUser"
                            class="reservationConfirmBackWrapper d-block d-md-flex justify-content-end">
                            <div
                                class="btn btn-yokumiru-gray mr-md-2"
                                @click="backToPaymentMethodModal">
                                お支払い方法選択に戻る
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <div
                        v-if="helper.isDefaultPlan(user.plan) && !helper.isCompanyLegacy(user)"
                        class="card mb-3">
                        <div class="card-header">クーポンの使用</div>
                        <div class="card-body">
                            <dl class="mb-0">
                                <dd class="mb-0">
                                    <div
                                        v-if="userCoupon"
                                        class="vc-user-coupon">
                                        <div class="vc-user-coupon__name">
                                            {{ userCoupon.name }}
                                        </div>
                                        <div class="vc-user-coupon__discount">
                                            <span>{{ userCoupon.discount.toLocaleString() }}</span><!--
                                        --><span>円引き</span>
                                        </div>
                                    </div>
                                    <div v-else>使用しない</div>
                                </dd>
                            </dl>
                            <div
                                v-if="!completed"
                                class="reservationConfirmBackWrapper d-block d-md-flex justify-content-end">
                                <div
                                    class="btn btn-yokumiru-gray mr-md-2"
                                    @click="backToPaymentMethodModal">
                                    クーポン選択に戻る
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">{{ $locale.type === 'consul' ? '金額（税込）' : '金額' }}</div>
                        <div class="card-body">
                            <dl class="mb-0">
                                <dd class="mb-0">
                                    <template v-if="$locale.type === 'consul'">
                                        <span v-if="estimate !== null">{{ `${estimate.total.toLocaleString()}円` }}</span>
                                    </template>
                                    <template v-else>
                                        <span>{{ `${ $locale.consultation_guest }終了後に確定` }}</span>
                                    </template>
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </template>

            <div v-if="matchingQuestions.length > 0 || commonQuestions.length > 0 || questions.length > 0" class="card mb-3">
                <div class="card-header">{{ $locale.question }}の回答</div>
                <div class="card-body">
                    <template v-if="doctorMenu === null">
                        <div v-for="q in matchingQuestions">
                            <p class="font-weight-bold mb-2">{{ q.title }}</p>
                            <ul v-if="Array.isArray( q.content ) && q.content.length > 0" class="pl-3">
                                <li v-for="c in q.content">{{ c }}</li>
                            </ul>
                            <p v-else-if="Array.isArray( q.content )">-</p>
                            <p v-else class="pre-wrap">{{ q.content || '-' }}</p>
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="q in prefixCommonQuestions">
                            <p class="font-weight-bold mb-2">{{ q.title }}</p>
                            <ul v-if="Array.isArray( q.content ) && q.content.length > 0" class="pl-3">
                                <li v-for="c in q.content">{{ c }}</li>
                            </ul>
                            <p v-else-if="Array.isArray( q.content )">-</p>
                            <p v-else class="pre-wrap">{{ q.content || '-' }}</p>
                        </div>

                        <div v-for="q in questions">
                            <p class="font-weight-bold mb-2">{{ q.title }}</p>
                            <ul v-if="Array.isArray( q.content ) && q.content.length > 0" class="pl-3">
                                <li v-for="c in q.content">{{ c }}</li>
                            </ul>
                            <p v-else-if="Array.isArray( q.content )">-</p>
                            <p v-else class="pre-wrap">{{ q.content || '-' }}</p>
                        </div>

                        <div v-for="q in suffixCommonQuestions">
                            <p class="font-weight-bold mb-2">{{ q.title }}</p>
                            <ul v-if="Array.isArray( q.content ) && q.content.length > 0" class="pl-3">
                                <li v-for="c in q.content">{{ c }}</li>
                            </ul>
                            <p v-else-if="Array.isArray( q.content )">-</p>
                            <p v-else class="pre-wrap">{{ q.content || '-' }}</p>
                        </div>
                    </template>

                    <div class="reservationConfirmBackWrapper d-block d-md-flex justify-content-end">
                        <div
                            v-if="!completed"
                            class="btn btn-yokumiru-gray mr-md-2"
                            @click="backToInterviewModal">
                            {{ $locale.question }}の回答に戻る
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-3">
                <div class="card-header">ご予約にあたってのお願い</div>
                <div class="card-body">
                    <div class="vc-notice">
                        <p>医師もスケジュールを空けて待機しておりますが、急患などの止むを得ない対応により、ご連絡もできず{{ $locale.consultation_host }}時間に遅れる、もしくは入室出来ない可能性がございます。</p>
                        <template v-if="$store.state.configs.subscription == 1">
                            <p>会員様が予約時刻に「{{ $locale.consultation_host }}室」に入室して、{{ $store.state.configs.consultation_absence_min_doctor }}分間お待ちいただいても医師の入室がなく{{ $locale.consultation_host }}が開始されない場合は、自動的にオンライン{{ $locale.consultation }}が終了し、{{ $locale.consultation_host }}予約は「キャンセル」されます。</p>
                            <p>医師の都合により{{ $locale.consultation }}がキャンセルされた場合には、{{ $locale.consultation_host }}料やキャンセル料は一切必要ありません。</p>
                            <p class="mb-0">
                                クレジットカードでお支払いただいた場合の{{ $locale.consultation_host }}料は、自動で返金処理が行われます。返金されるタイミングは、ご利用されたカード会社を介しての返金となるため、カード会社の締め日や規定により異なりますが、10日以内には処理がされます。詳細の確認をご希望の場合は、お使いのカード会社にお問い合わせください。
                            </p>
                        </template>
                        <template v-else>
                            <p>予約時間の5分経過後も医師の入室がなかった場合は、お手数ですがチャットに「{{ $locale.consultation_host }}時間に待機していたが、医師の入室がなかった」旨の記入をお願いいたします。</p>
                            <p class="mb-0">医師の都合によりオンライン{{ $locale.consultation_host }}ができなった場合は、{{ $locale.consultation_guest }}料やキャンセル料は発生いたしません。</p>
                        </template>
                    </div>
                </div>
            </div>

            <template v-if="isDoctorPass">
                <div
                    v-if="$store.state.configs.consultation_cancel_policy_doctor_pass !== null
                    && $store.state.configs.consultation_cancel_policy_doctor_pass !== ''"
                    class="card mb-3">
                    <div class="card-header">予約のキャンセルについて</div>
                    <div class="card-body">
                        <div
                            class="vc-notice vc-notice--pre-wrap"
                            v-html="$store.state.configs.consultation_cancel_policy_doctor_pass">
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="isFlatRate">
                <div
                    v-if="$store.state.configs.consultation_cancel_policy_flat_rate !== null
                    && $store.state.configs.consultation_cancel_policy_flat_rate !== ''"
                    class="card mb-3">
                    <div class="card-header">予約のキャンセルについて</div>
                    <div class="card-body">
                        <div
                            class="vc-notice vc-notice--pre-wrap"
                            v-html="$store.state.configs.consultation_cancel_policy_flat_rate">
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div
                    v-if="$store.state.configs.consultation_cancel_policy !== null
                    && $store.state.configs.consultation_cancel_policy !== ''"
                    class="card mb-3">
                    <div class="card-header">予約のキャンセルについて</div>
                    <div class="card-body">
                        <div
                            class="vc-notice vc-notice--pre-wrap"
                            v-html="$store.state.configs.consultation_cancel_policy">
                        </div>
                    </div>
                </div>
            </template>

            <hr>

            <div v-if="completed">
                <div class="col">
                    <div class="text-center">
                        <p>予約を確定しました。</p>

                        <div v-if="userAgent !== 'web'">
                            <div class="appDlBoxWrapper mt-2 mb-4">
                                <div class="appDlBoxContent">
                                    <p class="appDlBoxText">{{ $locale.consultation_host }}を受けるにはアプリが必要です。事前にインストールをお願いします。</p>
                                    <div class="d-flex justify-content-center align-items-center">
                                        <a :href="iosAppDownloadUrl" target="_blank">
                                            <img class="appDlBoxImg01" src="/images/common/btn-dl-apple.png">
                                        </a>
                                        <a :href="androidAppDownloadUrl" target="_blank">
                                            <img class="appDlBoxImg02" src="/images/common/btn-dl-googleplay.png">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center">
                            <div class="btn btn-yokumiru-gray mr-2" @click="close">閉じる</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="row">
                <div class="col">
                    <div class="text-center">
                        <p>上記内容で予約を確定してよろしいですか？</p>
                        <div
                            v-if="errors.stripe"
                            class="invalid-feedback d-flex justify-content-center mb-3">
                            <!-- @see app/Exceptions/Handler.php -->
                            <div v-if="errors.stripe.code === 'card_declined'">カード会社によって支払いが拒否されました。</div>
                            <div v-else-if="errors.stripe.type === 'card_error'">このカードは利用できません。</div>
                            <div v-else-if="['api_connection_error', 'api_error'].includes(errors.stripe.type)">
                                決済システムのメンテナンス中です。時間を置いて再度お試しください。
                            </div>
                        </div>

                        <div v-if="inProgress">
                            <b-spinner :variant="`yokumiru-user`"></b-spinner>
                        </div>
                        <div
                            v-else
                            class="d-flex justify-content-center">
                            <div
                                class="nextButton"
                                @click="handleOk">
                                予約を確定
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'
    import { mapMutations } from 'vuex'
    import { loadStripe } from '@stripe/stripe-js'

    export default {
        props: {
            dataPubkey: {
                type: String,
                default: null,
            },
            userAgent: {
                type: String,
                default: 'web',
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                isShowDoctorIntroduction: false,
                isShowDoctorMenuDescription: false,
                mode: null,
                user: null,
                doctor: null,
                doctorMenu: null,
                medicalCourse: null,
                schedule: null,
                prevConsultation: null,
                paymentMethod: null,
                questions: null,
                commonQuestions: null,
                matchingQuestions: null,
                userCoupon: null,
                failed: false,
                inProgress: false,
                completed: false,
                errors: {},
                schedule_exception: false,
                estimate: null,
                stripe: null,
            }
        },

        computed: {
            isLoadedState: function () {
                if (this.mode === 'default' || this.mode === 'auto') {
                    return this.user !== null
                        && this.doctor !== null
                        && this.doctorMenu !== null
                        && this.medicalCourse !== null
                        && this.schedule !== null
                        && this.paymentMethod !== null
                        && this.questions !== null
                        && this.commonQuestions !== null
                }
                else if (this.mode === 'matching') {
                    return this.user !== null
                        && this.medicalCourse !== null
                        && this.schedule !== null
                        && this.paymentMethod !== null
                        && this.questions !== null
                        && this.commonQuestions !== null
                }
            },

            /**
             * スタッフ判定
             *
             * @return {boolean}
             */
            isStaff: function () {
                return this.doctorMenu
                    && this.doctorMenu.doctor
                    && this.doctorMenu.doctor.full_name.includes('スタッフ')
            },

            /**
             * アプリのダウンロードURL（ios）
             */
            iosAppDownloadUrl: function () {
                if (this.$locale.type === 'consul') {
                    return 'https://apps.apple.com/jp/app/id1625616546'
                } else {
                    return 'https://apps.apple.com/jp/app/id1519400662'
                }
            },

            /**
             * アプリのダウンロードURL（android）
             */
            androidAppDownloadUrl: function () {
                if (this.$locale.type === 'consul') {
                    return 'https://play.google.com/store/apps/details?id=jp.realll.consul.yokumiru'
                } else {
                    return 'https://play.google.com/store/apps/details?id=jp.realll.yokumiru'
                }
            },

            /**
             * ドクターパス利用中かどうか
             * @return {*|boolean}
             */
            isDoctorPass: function () {
                return this.user && this.helper.isDoctorPass(this.user.plan)
            },

            /**
             * 定額プラン利用中かどうか
             * @return {*|boolean}
             */
            isFlatRate: function () {
                return this.user && this.helper.isFlatRatePlan(this.user.plan)
            },

            /**
             * 相談料の決済が必要かどうか
             * @return {boolean}
             */
            isPayPrice: function () {
                if (this.$locale.type === 'consul' && (!this.estimate || this.estimate.total < 1)) {
                    return false
                }
                if (this.doctorMenu && this.doctorMenu.is_health_package) {
                    return false
                }
                return this.user && this.user.plan.is_pay_consultation_price
            },

            /**
             * デフォルト問診のリスト（先頭表示）
             *
             * @return array
             */
            prefixCommonQuestions: function () {
                if (!this.commonQuestions) return []
                return this.commonQuestions.filter((question) => question.display_type === 'prefix')
            },

            /**
             * デフォルト問診のリスト（末尾表示）
             *
             * @return array
             */
            suffixCommonQuestions: function () {
                if (!this.commonQuestions) return []
                return this.commonQuestions.filter((question) => question.display_type === 'suffix')
            },

            /**
             * グループに所属しているかどうか
             *
             * @return {boolean}
             */
            isGroupUser: function () {
                return this.helper.isGroupUser(this.user)
            },

            /**
             * 所持クーポンのフィルタリング
             * （相談予約カテゴリのクーポンだけにする）
             *
             * @return {array}
             */
            filteredUserCoupons: function () {
                return this.helper.filteredUserCoupons(this.user)
            },

            /**
             * タイムゾーン併記
             * （Asia/Tokyo 診療開始 moment）
             *
             * @return {moment|null}
             */
            jstConsultationStart: function () {
                if (!this.schedule || !this.user) {
                    return null
                }

                return this.helper.jstTime(`${this.schedule.date.format('YYYY-MM-DD')} ${this.schedule.start_time}:00`, this.user.timezone)
            },

            /**
             * タイムゾーン併記
             * （Asia/Tokyo 診療終了 moment）
             *
             * @return {moment|null}
             */
            jstConsultationEnd: function () {
                if (!this.schedule || !this.user) {
                    return null
                }

                if (this.mode === 'default') {
                    return this.jstConsultationStart.clone().add(this.doctorMenu.consultation_minutes, 'minutes')
                }
                return this.jstConsultationStart.clone().add(this.medicalCourse.matching_minutes, 'minutes')
            },

            /**
             * タイムゾーン併記
             * （Asia/Tokyo 診療時間フォーマット）
             *
             * @return {string}
             */
            jstConsultationTimeFormat: function () {
                if (!this.jstConsultationStart || !this.jstConsultationEnd) {
                    return ''
                }

                let start = this.jstConsultationStart.format('ah:mm')
                let end = this.jstConsultationEnd.format('ah:mm')

                if (start.includes('午前12')) {
                    start = start.replace('午前12', '午前0')
                }
                if (end.includes('午前12')) {
                    end = end.replace('午前12', '午前0')
                }

                return `${start} - ${end} （日本時間）`
            },
        },

        created: async function() {
            bus.$on('open-modal-reservation-confirm', this.open)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-reservation-confirm')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function() {
                this.mode = this.$store.state.reservation.mode
                this.user = this.$store.state.reservation.user
                this.doctorMenu = this.$store.state.reservation.doctorMenu
                this.doctor = this.doctorMenu ? this.doctorMenu.doctor : null
                this.medicalCourse = this.$store.state.reservation.medicalCourse
                this.schedule = this.$store.state.reservation.schedule
                this.prevConsultation = this.$store.state.reservation.prevConsultation
                this.questions = this.$store.state.reservation.questions
                this.commonQuestions = this.$store.state.reservation.commonQuestions
                this.matchingQuestions = this.$store.state.reservation.matchingQuestions
                this.paymentMethod = this.$store.state.reservation.paymentMethod
                this.userCoupon = this.$store.state.reservation.userCoupon

                this.isShowDoctorIntroduction = false
                this.isShowDoctorMenuDescription = false

                this.fetchEstimate()
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function() {
                this.modalShow = false

                if (this.completed) {
                    this.completed = false
                    this.clearReservation()
                }
            },

            /**
             * 税込金額の見積もり
             *
             * @return {number|void}
             */
            fetchEstimate: function () {
                if (this.$locale.type !== 'consul') {
                    return
                }

                let endpoint = `${constants.user.consultations.endpoint.base}/estimate`
                endpoint += `?medical_course_id=${this.medicalCourse.id}`

                if (this.doctorMenu) {
                    endpoint += `&doctor_menu_id=${this.doctorMenu.id}`
                }
                if (this.userCoupon) {
                    endpoint += `&user_coupon_id=${this.userCoupon.id}`
                }

                axios.get(endpoint).then(({data}) => {
                    this.estimate = data.data
                })
            },

            /**
             * 予約を確定ボタン押下時
             * @param {object} e
             */
            handleOk: async function (e) {
                e.preventDefault()

                if (this.helper.isDraftByDoctor(this.prevConsultation)) {
                    await this.accept()
                }
                else {
                    await this.reserve()
                }
            },

            /**
             * 予約処理
             */
            reserve: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    medical_course_id: this.medicalCourse.id,
                    doctor_id: this.doctor ? this.doctor.id : null,
                    doctor_menu_id: this.doctorMenu ? this.doctorMenu.id : null,
                    start_time: this.startDateTime().format('YYYY-MM-DD HH:mm:ss'),
                    end_time: this.endDateTime().format('YYYY-MM-DD HH:mm:ss'),
                    questions: this.questions,
                    prefix_common_questions: this.prefixCommonQuestions,
                    suffix_common_questions: this.suffixCommonQuestions,
                    matching_questions: this.matchingQuestions,
                    payment_method_id: this.paymentMethod.id,
                    as_repeat: this.$store.state.reservation.asRepeat,
                    reserved_as: this.prevConsultation && this.prevConsultation.flg_cancel == 1 ? 'DRAFT_CANCEL' : null,
                }

                if (this.userCoupon) {
                    params.user_coupon_id = this.userCoupon.id
                }

                await axios.post(constants.user.consultations.endpoint.base, params)
                    .then(async ({data}) => {
                        if (data.data.client_secret === null) {
                            this.completeReservation()
                            bus.$emit('alert-success', '予約が完了しました。')
                            this.inProgress = false
                        }
                        else {
                            this.stripe = await loadStripe(this.dataPubkey, { locale: 'ja' })

                            // 3DS認証フロー
                            // @see https://github.com/sewii/Yokumiru/issues/987
                            this.stripe
                                .confirmCardPayment(data.data.client_secret, {
                                    payment_method: data.data.payment_method,
                                })
                                .then((result) => {
                                    if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
                                        this.completeReservation()
                                        bus.$emit('alert-success', '予約が完了しました。')
                                    }
                                    else {
                                        bus.$emit('alert-danger', '3Dセキュア認証がキャンセルされました。')
                                    }
                                    this.inProgress = false
                                })
                        }
                    })
                    .catch(({response}) => {
                        if (
                            response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')
                        ) {
                            this.errors = response.data.errors
                            if (this.errors.message) {
                                bus.$emit('alert-danger', this.errors.message[0])
                                this.inProgress = false
                                return
                            }
                            else if (this.errors.stripe) {
                                bus.$emit('alert-danger', '登録中のクレジットカードはご利用いただけません。エラー内容をご確認ください。')
                                this.inProgress = false
                                return
                            }
                        }
                        bus.$emit('alert-danger', 'システムエラーが発生しました。時間を置いて再度お試しください。')
                        this.inProgress = false
                    })
            },

            /**
             * 予約処理（医師によるドラフト予約の承認）
             */
            accept: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    questions: this.questions,
                    prefix_common_questions: this.prefixCommonQuestions,
                    suffix_common_questions: this.suffixCommonQuestions,
                    payment_method_id: this.paymentMethod.id,
                    user_coupon_id: this.userCoupon ? this.userCoupon.id : null,
                }

                const endpoint = constants.user.consultations.endpoint.base
                await axios.put(`${endpoint}/${this.prevConsultation.id}/accept`, params)
                    .then(async ({data}) => {
                        if (data.data.client_secret === null) {
                            this.completeReservation()
                            bus.$emit('alert-success', '予約が完了しました。')
                            this.inProgress = false
                        }
                        else {
                            this.stripe = await loadStripe(this.stripePubkey, { locale: 'ja' })

                            // 3DS認証フロー
                            // @see https://github.com/sewii/Yokumiru/issues/987
                            this.stripe
                                .confirmCardPayment(data.data.client_secret, {
                                    payment_method: data.data.payment_method,
                                })
                                .then((result) => {
                                    if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
                                        this.completeReservation()
                                        bus.$emit('alert-success', '予約が完了しました。')
                                    }
                                    else {
                                        bus.$emit('alert-danger', '3Dセキュア認証がキャンセルされました。')
                                    }
                                    this.inProgress = false
                                })
                        }
                    })
                    .catch(({response}) => {
                        if (
                            response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')
                        ) {
                            this.errors = response.data.errors
                            if (this.errors.message) {
                                bus.$emit('alert-danger', this.errors.message[0])
                                this.inProgress = false
                                return
                            }
                            else if (this.errors.stripe) {
                                bus.$emit('alert-danger', '登録中のクレジットカードはご利用いただけません。エラー内容をご確認ください。')
                                this.inProgress = false
                                return
                            }
                        }
                        bus.$emit('alert-danger', 'システムエラーが発生しました。時間を置いて再度お試しください。')
                        this.inProgress = false
                    })
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             */
            pushAnalyticsDataLayer: function () {
                if (this.$locale.type !== 'consul') return

                const doctorMenuId = this.doctorMenu ? this.doctorMenu.id : null
                const doctorMenuTitle = this.doctorMenu ? this.doctorMenu.title : null

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__completeReservation',
                    doctorMenuId: doctorMenuId,
                    doctorMenuTitle: doctorMenuTitle,
                })
            },

            /**
             * 予約フローの終了処理
             */
            completeReservation: function () {
                this.errors = {}
                this.completed = true
                this.pushAnalyticsDataLayer()

                if (this.helper.isDraft(this.prevConsultation) || this.helper.isDraftByDoctor(this.prevConsultation)) {
                    const endpoint = constants.user.consultations.endpoint.base

                    axios.delete(`${endpoint}/${this.prevConsultation.id}/draft`)
                        .then(() => bus.$emit('user-draft-deleted'))
                        .catch()
                }

                bus.$emit('user-reservation-completed')
                bus.$emit('clear-reservation-interview-questions')
                bus.$emit('close-modal-reservation-doctor-menus')
                bus.$emit('close-modal-reservation-doctor-menu-detail')
                bus.$emit('close-modal-reservation-interview')
                bus.$emit('close-modal-reservation-payment-method')
                bus.$emit('close-modal-doctor-profile')
            },

            /**
             * 相談開始日時フォーマット
             *
             * @return {moment}
             */
            startDateTime: function () {
                if (this.schedule.start_time === '24:00') {
                    this.schedule.start_time = '00:00'
                }

                const format = this.schedule.date.format('YYYY-MM-DD')

                return this.helper.jstTime(`${format} ${this.schedule.start_time}:00`, this.user.timezone)
            },

            /**
             * 相談終了日時フォーマット
             *
             * @return {moment}
             */
            endDateTime: function () {
                if (this.mode === 'default') {
                    return this.startDateTime().add(this.doctorMenu.consultation_minutes, 'minutes')
                }
                return this.startDateTime().add(this.medicalCourse.matching_minutes, 'minutes')
            },

            /**
             *「メニュー選択に戻る」ボタン押下時
             */
            backToDoctorMenusModal: function() {
                bus.$emit('close-modal-reservation-doctor-menu-detail')
                bus.$emit('close-modal-reservation-interview')
                bus.$emit('close-modal-reservation-payment-method')
                this.close()
            },

            /**
             *「日時選択に戻る」ボタン押下時
             */
            backToDoctorMenuDetailModal: function() {
                bus.$emit('close-modal-reservation-interview')
                bus.$emit('close-modal-reservation-payment-method')
                this.close()
            },

            /**
             *「お支払い方法選択に戻る」or「クーポン選択に戻る」ボタン押下時
             */
            backToPaymentMethodModal: function() {
                bus.$emit('close-modal-reservation-interview')
                this.close()
            },

            /**
             *「問診入力に戻る」ボタン押下時
             */
            backToInterviewModal: function() {
                this.close()
            },

            /**
             * 医師の詳細情報が設定されているかどうか
             *
             * @param {object} doctorMenu
             * @return {boolean}
             */
            hasDoctorIntroduction: function (doctorMenu) {
                return doctorMenu.doctor.introduction !== null ||
                    doctorMenu.doctor.doctor_histories.length > 0 ||
                    doctorMenu.doctor.doctor_licenses.length > 0
            },

            ...mapMutations({
                clearReservation: 'reservation/clearReservation',
            }),
        },
    }
</script>

<style scoped lang="scss">
.invalid-feedback {
    font-size: 14px;
}

.vc-user-coupon {
    .vc-user-coupon__name {
        font-size: .75rem;
        line-height: 1.3;
    }

    .vc-user-coupon__discount {
        margin-left: 1px;
        color: #5f6366;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;

        span {
            &:nth-child(2) {
                font-size: .75rem;
            }
        }
    }
}

.reservationModal {
    .table {
        th, td {
            font-size: .8rem;
        }
    }
}

.vc-timezone-box {
    display: inline-block;
    margin-top: 2px;
    padding: 5px 10px;
    color: #6e7275;
    background-color: #eee;
    border-radius: 4px;
    border: 1px solid #e6e6e6;

    span {
        line-height: 1.4;
    }
}

.pre-wrap {
    white-space: pre-wrap;
}

.vc-notice {
    &.vc-notice--pre-wrap {
        white-space: pre-wrap;
    }

    ul, ol {
        padding-left: 1rem;
    }

    h4 {
        font-size: 1.2rem;
    }
}

.reservationTimes {
    margin-bottom: 20px;
    color: #2A2E31;
    line-height: 1.1;

    div {
        &:nth-child(1) {
            margin-bottom: 6px;
            font-size: 14px;
            font-weight: bold;
            line-height: 1.1;
        }

        &:nth-child(2) {
            margin-bottom: 4px;
            font-size: 18px;
            font-weight: bold;

            span {
                &:nth-child(2) {
                    font-size: 17px;
                    font-weight: normal;
                }

                &:last-child {
                    font-size: 17px;
                    font-weight: normal;
                }
            }
        }

        &:nth-child(3) {
            font-size: 14px;

            span {
                &:nth-child(2) {
                    font-size: 13px;
                }
            }
        }
    }
}

.reservationConfirmBackWrapper {
    margin-top: 30px;

    @media screen and (max-width: 767px) {
        .btn {
            display: block;
            width: 70%;
            margin-left: auto;
            margin-right: auto;
            font-size: 0.8rem;
        }
    }
}

.modalContent {
    padding: 5px 14px;
}

.modalSection {
    position: relative;
}

.modalSectionPaddingTop {
    margin-top: 40px;
}

.modalSectionPaddingBottom {
    margin-bottom: 40px;
}

.modalHeading {
    margin-bottom: 15px;
    color: #7D868D;
    font-size: 16px;
    font-weight: bold;
}

.doctorMenuMedicalCourseName {
    color: #2A2E31;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.1;
}

.doctorMenuTitle {
    color: #2A2E31;
    font-size: 23px;
    font-weight: bold;
    line-height: 1.5;
}

.doctorMenuConsultationOverview {
    color: #7D868D;
    line-height: 1.1;
    font-size: 14px;
    font-weight: bold;

    .large {
        font-size: 19px;
    }

    .discounted {
        color: #CE798A;
    }

    .doctorMenuConsultationPrice {
        @media screen and (max-width: 767px) {
            div:nth-child(1) > span:nth-child(1) {
                display: none;
            }
        }

        .doctorMenuConsultationPriceOrigin {
            margin: 5px 0 0 5px;
            text-decoration: line-through;
        }
    }
}

.doctorMenuConsultationOverviewInfo {
    color: #7D868D;
    line-height: 1.1;
    font-size: 12px;

    > div {
        margin-top: 5px;
    }

    .doctorMenuConsultationOverviewInfoCoupon {
        color: #CE798A;
        font-weight: bold;
    }
}

.doctorMenuLabel {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 2px 12px;
    color: #53A15B;
    font-size: 13px;
    border: 1px solid #DFEDDC;
    background-color: #F3F8F2;
    border-radius: 6px;

    &:last-child {
        margin-right: 0;
    }
}

.divide {
    border-top: 1px dotted #ABB3BA;
}

.doctorMenuDoctorImage {
    position: relative;
    overflow: hidden;
    width: 130px;
    min-width: 130px;
    height: 130px;
    border-radius: 50%;

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.doctorMenuDoctorName {
    color: #2A2E31;
    font-weight: bold;

    span {
        font-size: 23px;

        &:nth-child(2) {
            font-size: 14px;
        }
    }
}

.doctorMenuDoctorDetail {
    margin: 5px 0 0 20px;

    @media screen and (max-width: 767px) {
        margin-left: 0;
    }
}

.doctorMenuDoctorMedicalCourse {
    display: inline-block;
    color: #7D868D;
    font-size: 14px;
    font-feature-settings: 'palt';
    line-height: 1;

    &::after {
        content: '、';
    }

    &:last-child {
        &::after {
            display: none;
        }
    }
}

.doctorMenuDoctorLabel {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 2px 12px;
    color: #B49834;
    font-size: 13px;
    border: 1px solid #EDECDC;
    background-color: #F7F8F2;
    border-radius: 6px;

    &:last-child {
        margin-right: 0;
    }
}

.descriptionWrapper {
    position: relative;
    height: 60px;
    overflow: hidden;
    padding: 15px;
    background-color: #F9F9F9;
    border: 1px solid #EDEDED;
    border-radius: 6px 6px 0 0;
    border-bottom: none;

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -5px;
        width: 100%;
        height: 5px;
        background: #fff;
        box-shadow: 0 -3px 4px #fff;
    }

    &.descriptionWrapperExtended {
        height: auto;
        border-radius: 6px;
        border-bottom: 1px solid #EDEDED;

        &::after {
            display: none;
        }
    }
}

.description {
    overflow: hidden;
    color: #757C83;
    font-size: 15px;
    line-height: 24px;
    white-space: pre-wrap;
}

.descriptionExtender {
    position: relative;
    left: -2px;
    margin-top: 6px;
    color: #7D868D;
    font-size: 15px;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        text-decoration: none;
    }
}

.doctorMenuDoctorHistory {
    color: #757C83;
    font-size: 15px;
}

.doctorMenuDoctorHistoryTitle {
    font-weight: bold;
    font-size: 15px;
}

.doctorMenuDoctorLicense {
    color: #757C83;
    font-size: 15px;
}

.doctorMenuDoctorLicenseTitle {
    font-weight: bold;
    font-size: 15px;
}

.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.appDlBoxWrapper {
    width: 100%;
    padding: 18px 15px;
    background: #eceff1;
    border-radius: 3px;

    .appDlBoxContent {
        .appDlBoxText {
            color: #333;
            font-size: 14px;
            text-align: center;
        }

        a {
            text-decoration: none;
        }

        .appDlBoxImg01,
        .appDlBoxImg02 {
            width: 180px;
            margin: 0 11px;

            @media screen and (max-width:767px) {
                width: 120px;
                margin: 0 6px;
            }
        }
    }
}
</style>
